import image from "../../Assets/AIOnDemand/proven-expertise.png";
const ProvenB2BExperience = () => {
    return (
        <section className="bg-gradient-to-r from-[#CBEFE9] to-[#5E74B4] pt-5 lg:pt-16 mb-3  lg:mb-10">
            <div className="flex flex-col max-w-[1400px] gap-10 mx-auto">
                <div className="flex flex-col gap-4 text-center mx-auto text-black">
                    <h2 className="text-3xl lg:text-5xl text-black ">Proven B2B Experience</h2>
                    <p className="text-md lg:text-xl">Over 350 Sales Pipelines Supercharged</p>
                </div>
                <img src={image} alt="salesmrkt clients" className="object-contain w-full h-auto" />
            </div>
        </section>
    );
}

export default ProvenB2BExperience;